import { BetslipUtilChannels } from "../../dependencies";
/**
 * @class
 * @implements {BsUtilMsgRouter}
 * @classdesc External message bus integration for BetslipUtilChannels. Listen/Post messages through sbMsgBus.
 */
var ExternalMsgRouter = /** @class */ (function () {
    function ExternalMsgRouter(msgBus) {
        var _this = this;
        this.msgBus = msgBus;
        this.listeners = {};
        Object.keys(BetslipUtilChannels.Listen.Commands).forEach(function (key) {
            _this.listeners["" + _this.msgBus.sbPrefix + BetslipUtilChannels.Listen.Commands[key]] = key;
        });
    }
    ExternalMsgRouter.prototype.attachListeners = function (onMessageReceived, context) {
        var _this = this;
        Object.keys(this.listeners).forEach(function (x) { return _this.msgBus.subscribe(x, onMessageReceived.bind(context, _this.listeners[x])); });
    };
    ExternalMsgRouter.prototype.detachListeners = function (onMessageReceived, context) {
        var _this = this;
        Object.keys(this.listeners).forEach(function (x) { return _this.msgBus.unsubscribe(x, onMessageReceived.bind(context)); });
    };
    ExternalMsgRouter.prototype.sendMessage = function (channel, data) {
        var _a;
        var msg = (_a = {},
            _a[channel] = data,
            _a);
        this.msgBus.post(msg);
    };
    return ExternalMsgRouter;
}());
export { ExternalMsgRouter };
//# sourceMappingURL=ExternalMsgRouter.js.map